import { useContext } from 'react';
import PageContext from './PageContext';
import PageInput from '../sub-components/PageInputCopy';

const OverrideInput = () =>{
    // get context from parent 
    const {
        overrideType, 
        overrideRate, 
        setOverrideRate,
        overrideSignAmt, 
        setOverrideSignAmt, 
    } = useContext(PageContext);

    // logic to determine whether to so rate input or amount input
    if (overrideType['id'] === '0'){
        return(
            <div>
                <PageInput width={'12em'} tag='Override Rate' value={overrideRate} setValue={setOverrideRate}/>
            </div>
        );
    }
    else if (overrideType['id'] === '1'){
        return(
            <div>
                <span>
                    <PageInput width={'12em'} tag='Override Amount' value={overrideSignAmt} setValue={setOverrideSignAmt} />
                </span>
            </div>
        );
    }
    else {
        return(
            <></>
        );
    }
}

export default OverrideInput;